import { TextField, TextareaAutosize, styled } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  bookingInfo: {
    textAlign: "center",
    padding: "15px 0 20px",
    background: "rgba(25, 118, 210, 0.04)",
  },
  btnBooking: {
    "&.MuiButton-root": {
      height: "56px",
      margin: "0px 8px 16px 8px",
      padding: 23,
      borderRadius: 99,
      color: "#fff",
      background: "linear-gradient(90deg, #03228F 0%, #0E73E4 100%)",
      boxShadow: "0px 8px 14px 0px #0D72E33D",
      textTransform: "uppercase",
      "&.Mui-disabled": {
        background: "rgba(0, 0, 0, 0.12)",
      },
    },
  },
}));

const FieldTextarea = styled(TextareaAutosize)(() => ({
  borderRadius: "4px",
  borderColor: "rgba(0, 0, 0, 0.23)",
  width: "calc(100% - 22px)",
  height: "112px !important",
  padding: "10px",
  fontSize: "16px",
  outline: "none",
}));

const CustomTextField = styled(TextField)(() => ({
  "& label": {
    color: "#061340 !important",
    "&.Mui-focused": {
      color: "#061340",
    },
  },
  "&:hover fieldset": {
    borderColor: "rgba(0, 0, 0, 0.23) !important",
  },
  "& .MuiOutlinedInput-root": {
    borderRadius: 8,
    "& fieldset": {
      borderColor: "#BDBDBD",
    },
    "&.Mui-focused fieldset": {
      borderWidth: 1,
      borderColor: "#BDBDBD",
    },
    "&.Mui-readOnly": {
      backgroundColor: "#e5e5e5",
    },
  },
  "& input:-webkit-autofill": {
    WebkitBoxShadow: "0 0 0 100px white inset !important",
    WebkitTextFillColor: "black !important",
    transition: "background-color 5000s ease-in-out 0s",
  },
}));

export { useStyles, FieldTextarea, CustomTextField };
